import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';
import StarIcon from '@mui/icons-material/Star';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import './WhyAlRasheed.css';

const WhyAlRasheed = () => {
  const { language } = useLanguage();
  const { content } = useContent();
  const t = content[language] || content.ar;

  const icons = [
    <StarIcon sx={{ fontSize: 60 }} />,
    <SpeedIcon sx={{ fontSize: 60 }} />,
    <AttachMoneyIcon sx={{ fontSize: 60 }} />,
    <SupportAgentIcon sx={{ fontSize: 60 }} />,
  ];

  return (
    <Box sx={{ py: 8, minHeight: 'calc(100vh - 200px)' }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          component="h1" 
          align="center" 
          gutterBottom
          sx={{ 
            fontWeight: 700,
            mb: 2,
            color: 'primary.main'
          }}
        >
          {t.whyTitle}
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          {t.whySubtitle}
        </Typography>

        <Grid container spacing={4}>
          {t.whyPoints?.map((point, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  p: 3,
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 6,
                  }
                }}
              >
                <Box 
                  sx={{ 
                    color: 'primary.main',
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {icons[index] || <StarIcon sx={{ fontSize: 60 }} />}
                </Box>
                <CardContent>
                  <Typography 
                    variant="h5" 
                    component="h3" 
                    gutterBottom
                    sx={{ fontWeight: 600, mb: 2 }}
                  >
                    {point.title}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    color="text.secondary"
                    sx={{ lineHeight: 1.8 }}
                  >
                    {point.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyAlRasheed;
